<div class='terminal-icon-container'>
  <nb-icon
    *ngIf="terminalTypeIcon === 'terminalType_0'"
    class='color-0-custom-icon__terminalType small'
    icon='monitor-outline'
    nbPrefix
    pack='eva'
    status='control'
  ></nb-icon>
  <nb-icon
    class='color-0-custom-icon__terminalType'
    icon='{{ terminalTypeIcon }}'
    nbPrefix
    pack='customIcons'
    status='control'
  ></nb-icon>
  <div *ngIf='terminal.status.color === 0' class='terminal-status-icon'>
    <svg
      class='alarm-svg'
      fill='#C2340A'
      height='16'
      viewBox='0 0 16 16'
      width='16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='3' cy='3' r='3'></circle>
    </svg>
  </div>
  <div *ngIf='terminal.status.color === 1' class='terminal-status-icon'>
    <svg
      class='alarm-svg'
      fill='#0CCE6B'
      height='16'
      viewBox='0 0 16 16'
      width='16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='3' cy='3' r='3'></circle>
    </svg>
  </div>
  <div *ngIf='terminal.status.color === 2' class='terminal-status-icon'>
    <svg
      class='alarm-svg'
      fill='#557788'
      height='16'
      viewBox='0 0 16 16'
      width='16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='3' cy='3' r='3'></circle>
    </svg>
  </div>
  <!-- {{ terminal.type['name'] }} {{ terminal.name }} -->
</div>
